import { DateTime } from "luxon";
import type { ICrmResponse } from "~/interfaces"
import { crmMapping } from "~/mappings/crmMapping";
import { getStateValue } from "~/utils";

export const setUserDataFromCrm = (data: ICrmResponse, dtEnd: string) => {

    for (const localKey in crmMapping) {
        const val = crmMapping[localKey as keyof typeof crmMapping](data);
        updateStateValue(localKey, val);
    }

    // expire date
    updateStateValue("dtEnd", data[dtEnd as keyof typeof data])

}

export const isDocumentExpired = (): boolean => {
    const releaseDate = getStateValue("documentRelease", null);
    const expireDate = getStateValue("documentExpire", null);
    if (expireDate) {
        return DateTime.fromFormat(expireDate, "dd/MM/yyyy") <= DateTime.now();
    }
    // if both expire and release dates are null, the document was reset because expired
    return !releaseDate
}

export const formatUserId = (value: string): string | number => {
    if(isNumeric(value)) return +value
    return value
}